// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorRegions = (client) => ({
    /**
     * `GET /vendor/regions`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListRegions
     * @source packages/modules/b2c-core/src/api/vendor/regions/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/regions", { method: "GET", query, headers }),
    /**
     * `GET /vendor/regions/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetRegionById
     * @source packages/modules/b2c-core/src/api/vendor/regions/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/vendor/regions/:id", [id]), { method: "GET", query, headers }),
});
//# sourceMappingURL=regions.js.map